import React from "react";

export default class Client extends React.Component {
  render() {
    return this.props.children;
  }
}
